/* custom.js — Zumbamboo Theme
   0. AOS Refresh on Load
   1. Matching Products Carousel
   2. Quick Shop Collapsible
   3. Quick Shop Add to Cart
   4. Collection Tabs
   5. Flickity Global Resize
   6. Color Swatch Hover
   7. Gift Wrap
   8. Tab Auto Height Fix
   9. Swatch Tabs
  10. Judge.me Badge Scroll Fix
  11. Fabric Markers
  12. Bundle Addon
  13. Delivery Date Cart Sync
  14. Bundle Addon — variant sync
  15. PDP Fabric
  16. Bundle Addon — "View more" toggle
*/

// 0. AOS Refresh on Load
// Recalculate AOS positions after all images load so sections below the fold trigger correctly.
window.addEventListener('load', function() {
  if (window.AOS) { AOS.refreshHard(); }
});

// 1. Matching Products Carousel
// Flickity carousel for "same print" products on PDP.
// Creates resizeObserver used by section 2 — carousel auto-resizes on collapsible toggle.
// Liquid: snippets/product-same-print.liquid → snippets/product-grid-item-quick-add.liquid
var matchingflkty;
var resizeObserver;

function initMatchingCarousel() {
  var el = document.querySelector('.matching-slide');
  if (!el || el.classList.contains('flickity-enabled')) return;
  matchingflkty = new Flickity(el, {
    wrapAround: true,
    groupCells: true,
    cellAlign: "left",
    prevNextButtons: false
  });
  resizeObserver = new ResizeObserver(function() {
    matchingflkty.resize();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMatchingCarousel);
} else {
  initMatchingCarousel();
}


// 2. Quick Shop Collapsible
// Toggles "Select a Size" variant list inside carousel product cards.
// Each collapsible is observed by resizeObserver (section 1)
// so carousel recalculates height on expand/collapse.
// MutationObserver re-inits when Flickity clones cells.
// Liquid: snippets/product-grid-item-quick-add.liquid
(function () {
  const processedToggles = new WeakSet();

  function initCollapsibles(root = document) {
    const toggles = root.querySelectorAll('.collapsible-toggle');

    toggles.forEach(function (toggle) {
      if (processedToggles.has(toggle)) return;

      const contentId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      if (!content) return;

      if (typeof resizeObserver !== 'undefined' && resizeObserver.observe) {
        resizeObserver.observe(content);
      }

      toggle.addEventListener('click', function () {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isExpanded));

        // Cancel the pending handler from a prior toggle — a stale expand
        // handler firing on the collapse transition would snap the panel open.
        if (content._transitionHandler) {
          content.removeEventListener('transitionend', content._transitionHandler);
          content._transitionHandler = null;
        }
        function onTransitionEnd(done) {
          content._transitionHandler = function (e) {
            if (e.target !== content || e.propertyName !== 'max-height') return;
            content.removeEventListener('transitionend', content._transitionHandler);
            content._transitionHandler = null;
            done();
          };
          content.addEventListener('transitionend', content._transitionHandler);
        }

        if (isExpanded) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            content.style.maxHeight = '0px';
          });
          onTransitionEnd(function () {
            content.setAttribute('aria-hidden', 'true');
          });
        } else {
          content.setAttribute('aria-hidden', 'false');
          content.style.maxHeight = content.scrollHeight + 'px';
          onTransitionEnd(function () {
            content.style.maxHeight = 'none';
          });
        }
      });

      processedToggles.add(toggle);
    });
  }

  function startCollapsibles() {
    initCollapsibles();

    var container = document.querySelector('.matching-slide');
    if (container) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) initCollapsibles(node);
          });
        });
      }).observe(container, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCollapsibles);
  } else {
    startCollapsibles();
  }
})();


// 3. Quick Shop Add to Cart
// AJAX add-to-cart for .variant-button clicks in product grid items.
// Event delegation — works with dynamically added buttons.
// Events: cart:build (rebuild drawer), cart:open (open drawer)
// Liquid: snippets/product-grid-item-quick-add.liquid
(function () {
  const addToCartAndRefreshDrawer = async function (variantId, quantity = 1, button = null) {
    if (!variantId) return;

    if (button) {
      button.classList.add('btn--loading');
      button.disabled = true;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!response.ok) {
        const error = await response.json();
        alert(error.description || 'Could not add to cart.');
        return;
      }

      const data = await response.json();

      document.dispatchEvent(new CustomEvent('icartAddToCartEvent', {
        detail: { handle: data.handle, id: data.id, variant_id: variantId, quantity },
        bubbles: true
      }));

      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (error) {
      console.error('Add to cart error:', error);
    } finally {
      if (button) {
        button.classList.remove('btn--loading');
        button.disabled = false;
      }
    }
  };

  document.addEventListener('click', function (e) {
    const button = e.target.closest('button.variant-button, a.variant-button');
    if (button) {
      e.preventDefault();
      const variantId = button.getAttribute('data-variant-id');
      const quantity = parseInt(button.getAttribute('data-quantity')) || 1;
      addToCartAndRefreshDrawer(variantId, quantity, button);
    }
  });

  // Cart rec variant dropdown — enable add button once a variant is selected
  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-rec-variant-select]');
    if (!select) return;
    const card = select.closest('.cart-rec-item');
    const btn = card?.querySelector('[data-rec-add]');
    if (btn) btn.disabled = !select.value;
  });

  // Cart rec separate add button — reads selected variant from dropdown then adds
  document.addEventListener('click', function (e) {
    const addBtn = e.target.closest('[data-rec-add]');
    if (!addBtn) return;
    e.preventDefault();
    const card = addBtn.closest('.cart-rec-item');
    const select = card?.querySelector('[data-rec-variant-select]');
    const variantId = select?.value;
    if (!variantId) {
      select?.focus();
      return;
    }
    addToCartAndRefreshDrawer(variantId, 1, addBtn).finally(() => {
      if (select) select.value = '';
      addBtn.disabled = true;
    });
  });
})();


// 3c. Cart Remove — AJAX intercept for .cart__remove clicks
// Replaces the default navigation to /cart/change?id=...&quantity=0 with an
// AJAX call to /cart/change.js, then rebuilds the cart drawer in place.
(function () {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.cart__remove');
    if (!link) return;
    e.preventDefault();

    const url = new URL(link.href, window.location.origin);
    const id = url.searchParams.get('id');
    if (!id) return;

    const item = link.closest('.cart__item');
    if (item) item.style.opacity = '0.4';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 0 }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        if (item) item.style.opacity = '';
      });
  });
})();


// 3d. Cart Recommendations — vertical wheel → horizontal scroll on desktop
// The grid uses overflow-x: auto, but mouse-wheel users on desktop expect
// vertical wheel to translate into horizontal movement inside the rail.
(function () {
  document.addEventListener('wheel', function (e) {
    const grid = e.target.closest('.cart-recommendations .grid');
    if (!grid) return;
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return; // already horizontal
    if (grid.scrollWidth <= grid.clientWidth) return;
    // deltaMode 1 = lines (Firefox wheel), 2 = pages — normalize to pixels
    let delta = e.deltaY;
    if (e.deltaMode === 1) delta *= 40;
    else if (e.deltaMode === 2) delta *= grid.clientWidth;
    // At either end of the rail, let the page scroll instead of trapping the wheel
    const atStart = grid.scrollLeft <= 0;
    const atEnd = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
    if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;
    e.preventDefault();
    grid.scrollLeft += delta;
  }, { passive: false });
})();


// 3b. Discount Code AJAX — apply/remove without navigating to /cart
// Applies a discount by calling `/discount/CODE` with redirect: 'manual' so the
// browser doesn't follow Shopify's redirect. Shopify still stores the code in
// the session. Then re-renders the widget and dispatches cart:build so the
// drawer items, subtotal, and discount pill stay in sync.
(function () {
  const tagSvg = '<svg class="cart__discount-pill-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';

  const escapeHtml = function (str) {
    return String(str).replace(/[&<>"']/g, s => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s]));
  };

  const renderWidget = async function () {
    const widget = document.querySelector('[data-discount-widget]');
    if (!widget) return;
    let cart;
    try {
      // Cache-bust so the server re-evaluates automatic discounts after cart changes.
      // Without this, some CDN layers return a stale /cart.js until the user reloads.
      cart = await fetch('/cart.js?t=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(r => r.json());
    } catch (_) { return; }
    const discounts = cart.cart_level_discount_applications || [];
    const hasRemovable = discounts.some(d => d.type === 'discount_code');
    // Skip the rewrite when discount state hasn't changed — innerHTML replacement
    // would wipe the code input (and its focus) while the user is typing.
    const stateKey = JSON.stringify(discounts.map(d => [d.type, d.title, d.total_allocated_amount]));
    if (widget.dataset.discountState === stateKey) return;
    widget.dataset.discountState = stateKey;
    if (discounts.length) {
      widget.setAttribute('data-has-discount', '');
      if (hasRemovable) {
        widget.setAttribute('data-has-removable-discount', '');
      } else {
        widget.removeAttribute('data-has-removable-discount');
      }
      const pillsHtml = discounts.map(d =>
        '<span class="cart__discount-pill">' + tagSvg +
          '<span class="cart__discount-pill-text">' + escapeHtml(d.title) + '</span>' +
        '</span>' +
        '<span class="cart__discount-applied-label">Applied!</span>'
      ).join('');
      widget.innerHTML =
        '<div class="cart__discount-applied" data-discount-applied>' +
          '<div class="cart__discount-pills">' + pillsHtml + '</div>' +
          (hasRemovable
            ? '<button type="button" class="cart__discount-remove" data-discount-remove>Remove</button>'
            : '') +
        '</div>';
    } else {
      widget.removeAttribute('data-has-discount');
      widget.removeAttribute('data-has-removable-discount');
      // Empty state → empty state: DOM already has the toggle/form, leave it alone
      if (widget.querySelector('[data-discount-toggle]')) return;
      widget.innerHTML =
        '<button type="button" class="cart__discount-toggle" data-discount-toggle aria-expanded="false" aria-controls="CartDiscountForm">' +
          '<span class="cart__discount-toggle-icon" aria-hidden="true">+</span>' +
          '<span class="cart__discount-toggle-text">Add Discount Code</span>' +
        '</button>' +
        '<div class="cart__discount-form" id="CartDiscountForm" role="group" aria-label="Discount code">' +
          '<input id="CartDiscountInput" type="text" class="cart__discount-input" placeholder="Discount code" autocomplete="off" data-discount-input>' +
          '<button type="button" class="cart__discount-apply" data-discount-apply>Apply</button>' +
        '</div>';
    }
  };

  const applyDiscount = async function (code) {
    const path = code ? '/discount/' + encodeURIComponent(code) : '/discount/';
    try {
      await fetch(path, { method: 'GET', credentials: 'same-origin', redirect: 'manual' });
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('cart:build'));
    await renderWidget();
  };

  const removeDiscount = async function () {
    try {
      await fetch('/discount/?clear=1', { method: 'GET', credentials: 'same-origin', redirect: 'manual' });
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('cart:build'));
    await renderWidget();
  };

  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('[data-discount-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      const w = toggleBtn.closest('[data-discount-widget]');
      if (!w) return;
      const open = w.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', String(open));
      if (open) w.querySelector('input')?.focus();
      return;
    }
    const applyBtn = e.target.closest('[data-discount-apply]');
    if (applyBtn) {
      e.preventDefault();
      const input = document.querySelector('[data-discount-input]');
      const code = (input?.value || '').trim();
      if (!code) return;
      applyBtn.disabled = true;
      applyDiscount(code).finally(() => { applyBtn.disabled = false; });
      return;
    }
    const removeBtn = e.target.closest('[data-discount-remove]');
    if (removeBtn) {
      e.preventDefault();
      removeBtn.disabled = true;
      removeDiscount().finally(() => { removeBtn.disabled = false; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('[data-discount-input]');
    if (!input) return;
    e.preventDefault();
    const code = input.value.trim();
    if (code) applyDiscount(code);
  });

  // Re-render the discount widget whenever the cart actually finishes rebuilding.
  // theme.js's buildCart() fetches /cart?view=ajax asynchronously and then writes
  // the new total into [data-subtotal]. We observe that write — if we rendered
  // earlier (on cart:build) /cart.js may still return stale data and miss
  // automatic discounts that Shopify just added/removed.
  let renderTimer;
  const scheduleRender = function () {
    clearTimeout(renderTimer);
    // Small tail delay — after subtotal is written, /cart.js should be consistent.
    renderTimer = setTimeout(renderWidget, 50);
  };
  const subtotalEl = document.querySelector('[data-subtotal]');
  if (subtotalEl) {
    new MutationObserver(scheduleRender).observe(subtotalEl, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  // Safety net: a long-delayed second pass in case the mutation observer
  // missed the rebuild (e.g. subtotal unchanged but discount changed).
  document.addEventListener('cart:build', function () {
    setTimeout(renderWidget, 600);
  });
})();


// 4. Collection Tabs
// Tab navigation for collection sections (Shop By Print, etc.).
// Called via inline onclick="openkbtab(event, tabId, sectionId)" in Liquid.
// Handles tab switching, scroll centering, Flickity re-init in hidden tabs.
// Liquid: sections/tabbed-collection-grids.liquid, sections/shop-by-print.liquid
function openkbtab(evt, kbtabName, sectionId) {
  var section = document.getElementById(sectionId);
  if (!section) return;

  var contents = section.getElementsByClassName('kbtab-content');
  var buttons = section.getElementsByClassName('kbtablinks');

  for (var i = 0; i < contents.length; i++) contents[i].style.display = 'none';
  for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove('active');

  var activeTab = document.getElementById(kbtabName);
  if (!activeTab) return;

  activeTab.style.display = 'block';
  evt.currentTarget.classList.add('active');

  var tabContainer = section.querySelector('.kbtab');
  if (tabContainer) {
    var button = evt.currentTarget;
    tabContainer.scrollLeft = button.offsetLeft - (tabContainer.offsetWidth - button.offsetWidth) / 2;
  }

  var carousels = activeTab.querySelectorAll('.flickity-enabled, [data-flickity]');
  if (carousels.length === 0) return;

  requestAnimationFrame(function() {
    carousels.forEach(function(el) {
      if (typeof Flickity === 'undefined') return;

      var flkty = Flickity.data ? Flickity.data(el) : null;

      if (!flkty && el.hasAttribute('data-flickity')) {
        try {
          var opts = JSON.parse(el.getAttribute('data-flickity') || '{}');
          flkty = new Flickity(el, opts);
        } catch (e) {
          flkty = new Flickity(el);
        }
      }

      if (flkty) {
        flkty.reloadCells();
        flkty.resize();
      }
    });
    // Flickity init/reload above may have created cloned cells (wrapAround) —
    // give their color swatches hover listeners (see section 6).
    if (window.initColorSwatches) window.initColorSwatches();
  });
}

// Auto-click first tab on page load
(function() {
  function initTabs() {
    var containers = document.getElementsByClassName('kbtab');
    for (var i = 0; i < containers.length; i++) {
      var section = containers[i].parentNode;
      var firstTab = section.getElementsByClassName('kbtablinks')[0];
      if (firstTab) firstTab.click();
    }
  }
  function scheduleInitTabs() {
    if ('requestIdleCallback' in window) {
      // timeout is required: with autoplaying carousels/videos the main thread
      // never goes idle, and an untimed idle callback can starve forever
      requestIdleCallback(initTabs, { timeout: 2000 });
    } else {
      setTimeout(initTabs, 200);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitTabs);
  } else {
    scheduleInitTabs();
  }
})();


// 5. Flickity Global Resize
// Resizes all Flickity carousels on window resize (debounced 150ms).
// After resize, waits for images to load then resizes again for correct height.
function resizeAllFlickity() {
  document.querySelectorAll('.flickity-enabled').forEach(function (elem) {
    var flkty = Flickity.data(elem);
    if (flkty) flkty.resize();
  });
}

function resizeFlickityAfterImages() {
  resizeAllFlickity();
  document.querySelectorAll('.flickity-enabled').forEach(function (elem) {
    var imgs = elem.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (!img.complete && !img._flktyResizePending) {
        img._flktyResizePending = true;
        img.addEventListener('load', function handler() {
          img.removeEventListener('load', handler);
          img._flktyResizePending = false;
          var flkty = Flickity.data(elem);
          if (flkty) flkty.resize();
        });
      }
    });
  });
}

var resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(resizeFlickityAfterImages, 150);
});


// 6. Color Swatch Hover
// Swaps product card image on color swatch hover in grid items.
// Deferred init via requestIdleCallback.
// Re-inits after Flickity render (cloned cells need listeners).
// Liquid: snippets/product-grid-item-quick-add.liquid
(function() {
  'use strict';

  var processed = new WeakSet();

  function initSwatches() {
    document.querySelectorAll('.grid-product').forEach(function(product) {
      if (processed.has(product)) return;
      processed.add(product);

      var swatches = product.querySelectorAll('.color-swatch--with-image');
      var images = product.querySelectorAll('.grid-product__color-image');

      if (swatches.length === 0) return;

      swatches.forEach(function(swatch) {
        if (swatch._hasListener) return;
        swatch._hasListener = true;

        swatch.onmouseenter = function() {
          var id = this.dataset.variantId;
          var img = this.dataset.variantImage;
          if (!id || !img) return;

          images.forEach(function(el) { el.classList.remove('is-active'); });
          swatches.forEach(function(el) { el.classList.remove('is-active'); });

          var target = product.querySelector('.grid-product__color-image--' + id);
          if (target) {
            target.style.backgroundImage = 'url(' + img + ')';
            target.classList.add('is-active');
            this.classList.add('is-active');
          }
        };

        swatch.onmouseleave = function() {
          var id = this.dataset.variantId;
          var target = product.querySelector('.grid-product__color-image--' + id);
          if (target) {
            target.classList.remove('is-active');
            this.classList.remove('is-active');
          }
        };
      });
    });
  }

  function deferSwatches() {
    if ('requestIdleCallback' in window) {
      // timeout is required: see scheduleInitTabs — untimed idle callbacks
      // starve on pages with autoplaying carousels/videos
      requestIdleCallback(initSwatches, { timeout: 2000 });
    } else {
      setTimeout(initSwatches, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferSwatches);
  } else {
    deferSwatches();
  }

  // Re-init for late Flickity clones happens via openkbtab (section 4), which
  // calls window.initColorSwatches after creating/reloading carousels.
  window.initColorSwatches = initSwatches;
})();


// 7. Gift Wrap
// Adds gift wrap product to cart with optional message.
// Checkbox in cart drawer/page opens modal. Syncs checkbox
// when gift item is removed via remove button.
// Liquid: snippets/gift-wrap.liquid
// Rendered in: snippets/cart-drawer.liquid, sections/main-cart.liquid
(function() {
  var giftProductId = null;

  function initGiftWrap() {
    document.querySelectorAll('.gift-wrap').forEach(function(wrap) {
      if (wrap.dataset.giftWrapInit) return;
      wrap.dataset.giftWrapInit = 'true';

      var checkbox = wrap.querySelector('.gift-wrap__checkbox');
      var overlay = wrap.querySelector('.gift-wrap__modal-overlay');
      var closeBtn = wrap.querySelector('.gift-wrap__modal-close');
      var saveBtn = wrap.querySelector('.gift-wrap__save');
      var textarea = wrap.querySelector('.gift-wrap__message');
      var charCurrent = wrap.querySelector('.gift-wrap__char-current');
      var variantId = wrap.dataset.giftVariantId;
      var productId = wrap.dataset.giftProductId;
      giftProductId = productId;

      // Move modal to body — position:fixed breaks inside drawer transform
      if (overlay && overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
        overlay.addEventListener('mousedown', function(e) { e.stopPropagation(); });
        overlay.addEventListener('mouseup', function(e) { e.stopPropagation(); });
        overlay.addEventListener('click', function(e) { e.stopPropagation(); });
      }

      function openModal() {
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      function refreshCart() {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

      function getGiftItemKey() {
        // Prefer the freshly-stored key from the last save (if present and
        // still a real Shopify line-item key, not the legacy "exists" marker).
        var stored = wrap.dataset.giftItemKey;
        if (stored && stored !== 'exists') {
          return Promise.resolve(stored);
        }
        // Cache-bust — otherwise a stale /cart.js can miss a just-removed item.
        return fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            for (var i = 0; i < cart.items.length; i++) {
              if (String(cart.items[i].product_id) === String(productId)) {
                return cart.items[i].key;
              }
            }
            return null;
          });
      }

      function removeGiftFromCart() {
        return getGiftItemKey().then(function(key) {
          if (!key) return;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function(r) {
            if (!r.ok) throw new Error('gift wrap remove failed');
          });
        }).then(function() {
          wrap.dataset.giftItemKey = '';
          checkbox.checked = false;
          refreshCart();
        });
      }

      checkbox.addEventListener('change', function() {
        if (checkbox.checked) {
          openModal();
        } else {
          removeGiftFromCart().catch(function() {
            checkbox.checked = true; // item is still in the cart
            alert('Could not remove gift wrap. Please try again.');
          });
        }
      });

      textarea.addEventListener('input', function() {
        charCurrent.textContent = textarea.value.length;
      });

      closeBtn.addEventListener('click', function() {
        closeModal();
        if (!wrap.dataset.giftItemKey) checkbox.checked = false;
      });

      overlay.querySelector('.gift-wrap__modal').addEventListener('click', function(e) {
        e.stopPropagation();
      });
      overlay.addEventListener('click', function() {
        closeModal();
        if (!wrap.dataset.giftItemKey) checkbox.checked = false;
      });

      saveBtn.addEventListener('click', function() {
        saveBtn.disabled = true;
        saveBtn.textContent = 'Saving...';
        var message = textarea.value.trim();

        var addItem = function() {
          var body = { id: parseInt(variantId), quantity: 1, properties: {} };
          if (message) body.properties['Gift Message'] = message;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(r) {
            // 422 = sold out / cart limit — must reach .catch, not the success path
            if (!r.ok) throw new Error('gift wrap add failed');
            return r.json();
          });
        };

        var existingKey = wrap.dataset.giftItemKey;
        var promise;
        if (existingKey) {
          promise = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existingKey, quantity: 0 })
          }).then(addItem);
        } else {
          promise = addItem();
        }

        promise.then(function(item) {
          wrap.dataset.giftItemKey = item.key || '';
          checkbox.checked = true;
          closeModal();
          refreshCart();
        }).catch(function() {
          alert('Could not add gift wrap. Please try again.');
        }).finally(function() {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save';
        });
      });
    });
  }

  // Sync checkbox with cart state (debounced)
  function syncGiftWrapState() {
    if (!giftProductId) return;
    // Cache-bust — other cart mutations (discount, qty change) may have
    // updated line-item keys in ways /cart.js needs to reflect immediately.
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var foundKey = '';
        for (var i = 0; i < cart.items.length; i++) {
          if (String(cart.items[i].product_id) === String(giftProductId)) {
            foundKey = cart.items[i].key;
            break;
          }
        }
        document.querySelectorAll('.gift-wrap').forEach(function(wrap) {
          var cb = wrap.querySelector('.gift-wrap__checkbox');
          if (cb) cb.checked = !!foundKey;
          // Store the real line-item key so later remove/edit flows work.
          wrap.dataset.giftItemKey = foundKey;
        });
      })
      .catch(function() {}); // background sync — retried on the next cart mutation
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrap);
  } else {
    initGiftWrap();
  }
  document.addEventListener('page:loaded', initGiftWrap);

  var syncTimer;
  var cartObserver = new MutationObserver(function() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGiftWrapState, 300);
  });
  function observeCartProducts() {
    document.querySelectorAll('[data-products]').forEach(function(el) {
      cartObserver.observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartProducts);
  } else {
    observeCartProducts();
  }
  document.addEventListener('page:loaded', observeCartProducts);
})();


// 8. Tab Auto Height Fix
// theme.js sets fixed pixel height on collapsible tabs after transition
// but doesn't set height:auto. Lazy images in closed tabs have 0 height
// so content gets clipped on open. Fix: set auto after transition ends.
document.addEventListener('transitionend', function(e) {
  var el = e.target;
  if (el.classList.contains('collapsible-content') && el.classList.contains('is-open')) {
    el.style.height = 'auto';
  }
});


// 9. Swatch Tabs
// Click handler for swatch style tabs on PDP (Printed/Solid/Custom).
// Event delegation — works with dynamically added swatches.
// Liquid: snippets/product-swatches.liquid
document.addEventListener('click', function(e) {
  var tab = e.target.closest('.swatch-tab');
  if (!tab) return;
  var container = tab.closest('.swatch-tabs');
  if (!container) return;
  var wrapper = container.parentElement;
  var tabs = container.querySelectorAll('.swatch-tab');
  var contents = wrapper.querySelectorAll('.swatch-tab-content');
  tabs.forEach(function(t) { t.classList.remove('active'); });
  contents.forEach(function(c) { c.classList.remove('active'); });
  tab.classList.add('active');
  var target = wrapper.querySelector('#' + tab.dataset.tab);
  if (target) target.classList.add('active');
});

// 10. Judge.me Badge Scroll Fix
// Judge.me uses jQuery animate({scrollTop}) which calculates target position
// once at click time. But lazy images between badge and widget load during
// scroll, increasing page height and pushing the widget down — so the
// animation ends at the wrong position on first click.
// Fix: intercept in capture phase, stop Judge.me's handler, then scroll
// with requestAnimationFrame that recalculates target each frame.
// Also drives .review-badge (snippets/product-review-badge.liquid), the theme
// replacement for the app preview badge.
// Widget selector covers both review blocks: the all-reviews block renders
// .jdgm-all-reviews-widget-v2025, the older per-product block .jdgm-review-widget.
// querySelector returns whichever appears first in the document.
document.addEventListener('click', function(e) {
  if (!e.target.closest('.jdgm-prev-badge, .review-badge')) return;
  e.stopPropagation();

  var widget = document.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-review-widget, .jdgm-all-reviews-widget');
  if (!widget) return;

  var start = window.scrollY;
  var duration = 600;
  var startTime = performance.now();

  function step(now) {
    var elapsed = now - startTime;
    var progress = Math.min(elapsed / duration, 1);
    // easeInOutCubic
    var ease = progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    // Recalculate target each frame (accounts for lazy image loads)
    var target = widget.getBoundingClientRect().top + window.scrollY;
    var pos = start + (target - start) * ease;
    window.scrollTo(0, pos);
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}, true);


// 11. Cart Drawer Recommendations — refetch on cart:build
// Container is rendered empty by snippets/cart-recommendations-placeholder.liquid. This
// populates and refreshes it based on cart state:
//   - Cart has items → anchor = last added item, intent=complementary
//     (falls back to intent=related if merchant hasn't set complementary in
//     Search & Discovery app)
//   - Cart empty + on PDP → anchor = current product, intent=related
//   - Cart empty + non-PDP → hide block
// Listens to the [data-subtotal] mutation (same signal the discount widget
// uses) so it fires AFTER theme.js finishes rebuilding the cart.
(function () {
  const container = document.querySelector('[data-cart-recs]');
  if (!container) return;

  const inner = container.querySelector('[data-cart-recs-inner]');
  const baseUrl = container.dataset.recUrl;
  const limit = parseInt(container.dataset.recLimit, 10) || 4;
  const pageProductId = container.dataset.pageProductId || '';

  if (!inner || !baseUrl) return;

  let lastSignature = '';
  let inFlight = null;
  let dirty = false; // Re-run once after current fetch if cart changed mid-flight.

  const fetchRecs = async function (productId, intent) {
    const url = baseUrl + '?section_id=cart-recommendations&product_id=' + encodeURIComponent(productId)
      + '&intent=' + intent + '&limit=' + limit + '&t=' + Date.now();
    const res = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) return null;
    const text = await res.text();
    const tmp = document.createElement('div');
    tmp.innerHTML = text;
    // Section endpoint returns the <product-recommendations> wrapper with a
    // `.product-recommendations` inside when recs exist, otherwise empty.
    const grid = tmp.querySelector('.product-recommendations .grid');
    if (!grid || grid.children.length === 0) return null;
    return grid.outerHTML;
  };

  const refresh = async function () {
    let cart;
    try {
      cart = await fetch('/cart.js?t=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(r => r.json());
    } catch (err) {
      return;
    }

    let anchorId = '';
    let intent = 'related';

    if (cart.items && cart.items.length > 0) {
      // Shopify orders cart.items newest-first (index 0 = last added).
      anchorId = String(cart.items[0].product_id);
      intent = 'complementary';
    } else if (pageProductId) {
      anchorId = pageProductId;
      intent = 'related';
    } else {
      // Cart empty + non-PDP → hide
      container.hidden = true;
      inner.innerHTML = '';
      lastSignature = 'hidden';
      return;
    }

    const signature = anchorId + '|' + intent;
    if (signature === lastSignature) return;

    // Already fetching — mark dirty so we re-run once the current fetch ends.
    if (inFlight) { dirty = true; return; }

    inFlight = (async () => {
      try {
        let gridHtml = await fetchRecs(anchorId, intent);
        // Complementary is merchant-curated — if empty, try related.
        if (!gridHtml && intent === 'complementary') {
          gridHtml = await fetchRecs(anchorId, 'related');
        }
        if (gridHtml) {
          inner.innerHTML = gridHtml;
          container.hidden = false;
          lastSignature = signature;
          // Re-register any [data-aos] elements we just injected so AOS
          // eventually fades them in (AOS.init uses disableMutationObserver:true).
          if (window.AOS) {
            try { AOS.refreshHard(); } catch (e) {}
          }
        } else {
          container.hidden = true;
          inner.innerHTML = '';
          lastSignature = 'hidden';
        }
      } finally {
        inFlight = null;
        if (dirty) { dirty = false; refresh(); }
      }
    })();
  };

  // Initial population once DOM is ready (drawer container exists).
  refresh();

  // Refresh on subtotal mutation — same signal the discount widget uses. This
  // fires AFTER theme.js's buildCart() writes new data, so /cart.js is fresh.
  let refreshTimer;
  let lastObserverRunAt = 0;
  const scheduleRefresh = function () {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      lastObserverRunAt = Date.now();
      refresh();
    }, 80);
  };
  const subtotalEl = document.querySelector('[data-subtotal]');
  if (subtotalEl) {
    new MutationObserver(scheduleRefresh).observe(subtotalEl, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  // Safety net: if the mutation observer hasn't fired ~1s after cart:build
  // (e.g. subtotal unchanged but cart contents changed), run refresh anyway.
  document.addEventListener('cart:build', function () {
    setTimeout(function () {
      if (Date.now() - lastObserverRunAt > 500) refresh();
    }, 600);
  });
})();


// 11. Fabric Markers PDP add-on
// Checkbox row that adds an extra product alongside the main add-to-cart. On form submit
// (capture phase, before theme.js): if the row is ticked, AJAX-add the markers first, then
// re-dispatch submit so the theme handler adds the main product. The row is hidden while the
// markers are in the cart, and shown again when they are removed from the side cart.
// Liquid: snippets/product-fabric-markers.liquid (row 1 of the bundle-addon box, or a
// standalone bundle-style box when the bundle block does not show)
(function() {
  var fmProductId = null;

  // Hide the row while the markers are in the cart, re-show it (unticked) once they are gone.
  function setInCart(fm, inCart) {
    fm.hidden = inCart;
    var cb = fm.querySelector('[data-fm-checkbox]');
    if (cb) cb.checked = false;
  }

  function syncFabricMarkersState() {
    if (!fmProductId) return;
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var inCart = cart.items.some(function(item) {
          return String(item.product_id) === String(fmProductId);
        });
        document.querySelectorAll('[data-fabric-markers]').forEach(function(fm) {
          setInCart(fm, inCart);
        });
      });
  }

  function initFabricMarkers() {
    // The bundle-addon block renders the markers as its row 1 ([data-fm-inline]); drop the
    // standalone fabric_markers block of that section so only one checkbox drives the cart.
    document.querySelectorAll('[data-fm-inline]').forEach(function(row) {
      var sec = row.closest('.product-section');
      if (!sec) return;
      sec.querySelectorAll('[data-fm-standalone]').forEach(function(el) {
        (el.closest('.product-block') || el).remove();
      });
    });

    document.querySelectorAll('[data-fabric-markers]').forEach(function(fm) {
      if (fm.dataset.fmInit) return;
      fm.dataset.fmInit = 'true';

      var checkbox = fm.querySelector('[data-fm-checkbox]');
      if (!checkbox) return;

      fmProductId = fm.dataset.fmProductId;

      var section = fm.closest('.product-section');
      if (!section) return;
      var form = section.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (form._fmListenerAttached) return;
      form._fmListenerAttached = true;

      form.addEventListener('submit', function(e) {
        if (form._fmBypass) return;
        // Block re-entry while our AJAX is in flight — a second submit would add the markers again.
        if (form._fmBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        if (fm.hidden || !checkbox.checked) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        form._fmBusy = true;

        // Show spinner immediately — theme's submit handler is blocked until
        // our AJAX resolves, so without this the button looks idle for ~1s.
        var btn = form.querySelector('.add-to-cart');
        if (btn) btn.classList.add('btn--loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(fm.dataset.fmVariantId), quantity: 1 })
        }).then(function(r) {
          // 422 = sold out / cart limit — keep the row on failure
          if (!r.ok) throw new Error('fabric markers add failed');
          setInCart(fm, true);
          form._fmBusy = false;
          form._fmBypass = true;
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          form._fmBypass = false;
        }).catch(function() {
          form._fmBusy = false;
          if (btn) btn.classList.remove('btn--loading');
          alert('Could not add Fabric Markers. Please try again.');
        });
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFabricMarkers);
  } else {
    initFabricMarkers();
  }
  document.addEventListener('page:loaded', initFabricMarkers);

  // Re-sync after any cart mutation (side-cart remove, qty change, etc.).
  // 300ms delay matches gift-wrap pattern — gives /cart.js time to settle.
  var syncTimer;
  document.addEventListener('cart:build', function() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFabricMarkersState, 300);
  });
})();

// 12. Bundle Addon — add checked addon products alongside main add-to-cart
// Intercepts form submit (capture phase), AJAX-adds checked addon variants,
// then re-dispatches so theme.js adds the main product.
// Liquid: snippets/product-bundle-addon.liquid
(function() {
  function initBundleAddon() {
    var addon = document.querySelector('[data-bundle-addon]');
    if (!addon) return;

    // Guarded — initBundleAddon runs on both DOMContentLoaded and page:loaded;
    // the form submit attach below has its own _bundleAddonAttached guard.
    if (addon._bundleChangeAttached) return;
    addon._bundleChangeAttached = true;

    // Update displayed price and image when variant select changes
    addon.addEventListener('change', function(e) {
      var select = e.target.closest('[data-bundle-variant-select]');
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var item = select.closest('[data-bundle-item]');
      var priceEl = item.querySelector('[data-bundle-price]');
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      var imgEl = item.querySelector('.bundle-addon__image');
      if (imgEl && option.dataset.image) {
        imgEl.src = option.dataset.image;
        imgEl.removeAttribute('srcset');
      }
    });

    var section = addon.closest('.product-section');
    if (!section) return;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form || form._bundleAddonAttached) return;
    form._bundleAddonAttached = true;

    form.addEventListener('submit', function(e) {
      if (e._bundleHandled) return;
      // Block re-entry while the addon AJAX is in flight — checkboxes are still
      // checked then, so a second submit would add addons and main product again.
      if (form._bundleBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }

      var checkboxes = addon.querySelectorAll('[data-bundle-checkbox]:checked');
      if (!checkboxes.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      form._bundleBusy = true;

      var btn = form.querySelector('.add-to-cart');
      if (btn) btn.classList.add('btn--loading');

      // Buy buttons name input block (snippets/product-form-with-name-input.liquid): the name the
      // customer typed for the main product is copied onto every add-on line as the same property.
      var nameInput = form.querySelector('.name-form[name="properties[name]"]');
      var addonName = nameInput ? nameInput.value.trim() : '';

      var items = [];
      checkboxes.forEach(function(cb) {
        var item = cb.closest('[data-bundle-item]');
        if (!item) return;
        var select = item.querySelector('[data-bundle-variant-select]');
        if (!select || !select.value) return;
        var option = select.options[select.selectedIndex];
        if (option && option.disabled) return;
        var line = { id: parseInt(select.value), quantity: 1 };
        if (addonName) line.properties = { name: addonName };
        items.push(line);
      });

      function redispatch() {
        form._bundleBusy = false;
        var evt = new Event('submit', { bubbles: true, cancelable: true });
        evt._bundleHandled = true;
        form.dispatchEvent(evt);
      }

      if (!items.length) { redispatch(); return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(redispatch)
      .catch(redispatch);
    }, true);
  }
  document.addEventListener('DOMContentLoaded', initBundleAddon);
  document.addEventListener('page:loaded', initBundleAddon);
})();

// 13. Bundle Addon v2 — complementary products priority + same-print/swatch fallback
// Fetches Shopify Complementary products first, falls back to Liquid-rendered items.
// Liquid: snippets/product-bundle-addon-v2.liquid
(function() {
  function sizedUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=120';
  }

  // Escape API data before HTML interpolation — titles like 'Blanket 30" x 40"'
  // would otherwise break out of the attribute quotes below.
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ccode = ' ISO' suffix from the 'currency-code' snippet (empty on the base market),
  // passed in via [data-currency-code] so JS-built items price like the Liquid ones.
  function buildItemHTML(product, idx, ccode) {
    var variant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
    var imgSrc = sizedUrl(product.featured_image);
    var imgHTML = imgSrc ? '<img src="' + esc(imgSrc) + '" class="bundle-addon__image" loading="lazy">' : '';
    var cbId = 'bundle-cb-rec-' + product.id + '-' + idx;
    var fmtPrice = theme.Currency.formatMoney(variant.price) + ccode;

    var opts = '';
    product.variants.forEach(function(v) {
      var vImg = sizedUrl(v.featured_image ? v.featured_image.src : product.featured_image);
      var vPrice = theme.Currency.formatMoney(v.price) + ccode;
      opts += '<option value="' + v.id + '"' +
        (v.available ? '' : ' disabled') +
        (v.id === variant.id ? ' selected' : '') +
        ' data-price="' + esc(vPrice) + '" data-image="' + esc(vImg) + '">' +
        esc(v.title) + (v.available ? '' : ' — Sold out') + '</option>';
    });

    return '<div class="bundle-addon__item" data-bundle-item data-bundle-product-url="' + esc(product.url) + '">' +
      '<span class="bundle-addon__image-wrap">' + imgHTML + '</span>' +
      '<span class="bundle-addon__info">' +
        '<a href="' + esc(product.url) + '" class="bundle-addon__title">' + esc(product.title) + '</a>' +
        '<span class="bundle-addon__price" data-bundle-price>' + fmtPrice + '</span>' +
        '<select class="bundle-addon__select" data-bundle-variant-select>' + opts + '</select>' +
      '</span>' +
      '<input type="checkbox" id="' + cbId + '" class="bundle-addon__checkbox" data-bundle-checkbox>' +
      '<label class="bundle-addon__cb-label" for="' + cbId + '"></label>' +
    '</div>';
  }

  function attachHandlers(addon) {
    addon.addEventListener('change', function(e) {
      var select = e.target.closest('[data-bundle-variant-select]');
      if (!select) return;
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var item = select.closest('[data-bundle-item]');
      var priceEl = item.querySelector('[data-bundle-price]');
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      var imgEl = item.querySelector('.bundle-addon__image');
      if (imgEl && option.dataset.image) {
        imgEl.src = option.dataset.image;
        imgEl.removeAttribute('srcset');
      }
    });

    var section = addon.closest('.product-section');
    if (!section) return;
    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form || form._bundleAddonAttached) return;
    form._bundleAddonAttached = true;

    form.addEventListener('submit', function(e) {
      if (e._bundleHandled) return;
      // Block re-entry while the addon AJAX is in flight — checkboxes are still
      // checked then, so a second submit would add addons and main product again.
      if (form._bundleBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      var checkboxes = addon.querySelectorAll('[data-bundle-checkbox]:checked');
      if (!checkboxes.length) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      form._bundleBusy = true;

      var btn = form.querySelector('.add-to-cart');
      if (btn) btn.classList.add('btn--loading');

      // Buy buttons name input block (snippets/product-form-with-name-input.liquid): the name the
      // customer typed for the main product is copied onto every add-on line as the same property.
      var nameInput = form.querySelector('.name-form[name="properties[name]"]');
      var addonName = nameInput ? nameInput.value.trim() : '';

      var items = [];
      checkboxes.forEach(function(cb) {
        var item = cb.closest('[data-bundle-item]');
        if (!item) return;
        var select = item.querySelector('[data-bundle-variant-select]');
        if (!select || !select.value) return;
        var option = select.options[select.selectedIndex];
        if (option && option.disabled) return;
        var line = { id: parseInt(select.value), quantity: 1 };
        if (addonName) line.properties = { name: addonName };
        items.push(line);
      });

      function redispatch() {
        form._bundleBusy = false;
        var evt = new Event('submit', { bubbles: true, cancelable: true });
        evt._bundleHandled = true;
        form.dispatchEvent(evt);
      }

      if (!items.length) { redispatch(); return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(redispatch)
      .catch(redispatch);
    }, true);
  }

  function initBundleAddonV2() {
    var addon = document.querySelector('[data-bundle-addon-v2]');
    if (!addon || addon._bundleInit) return;
    addon._bundleInit = true;

    var productId = addon.dataset.productId;
    var ccode = addon.dataset.currencyCode || '';
    var fallbackItems = addon.querySelectorAll('[data-bundle-fallback]');

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=complementary')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var skipPersonalized = addon.hasAttribute('data-skip-personalized');
        var products = (data.products || []).filter(function(p) {
          if (String(p.id) === productId) return false;
          if (!skipPersonalized) return true;
          // Recommendations JSON has no metafields: personalized = tagged customily or teeinblue here.
          var tags = Array.isArray(p.tags)
            ? p.tags.map(function(t) { return t.toLowerCase(); })
            : (typeof p.tags === 'string' ? p.tags.split(',').map(function(t) { return t.trim().toLowerCase(); }) : []);
          return tags.indexOf('customily') === -1 && tags.indexOf('teeinblue') === -1;
        }).slice(0, 2);

        if (products.length) {
          fallbackItems.forEach(function(el) { el.remove(); });
          var html = '';
          products.forEach(function(p, i) { html += buildItemHTML(p, i, ccode); });
          addon.insertAdjacentHTML('beforeend', html);
          addon.style.visibility = 'visible';
        } else if (fallbackItems.length) {
          addon.style.visibility = 'visible';
        } else {
          addon.style.display = 'none';
        }
        attachHandlers(addon);
      })
      .catch(function() {
        if (fallbackItems.length) addon.style.visibility = 'visible';
        else addon.style.display = 'none';
        attachHandlers(addon);
      });
  }

  document.addEventListener('DOMContentLoaded', initBundleAddonV2);
  document.addEventListener('page:loaded', initBundleAddonV2);
})();

// 14. Bundle Addon — sync addon variant dropdowns to the main product variant
// Gated by the [data-bundle-sync] attr, which the snippet now adds for every bundle-addon block.
// Runs on page load AND on every main-product variant change. For each addon it picks the
// option sharing the most tokens with the main variant; a COLOR match is weighted above a
// size-only match (color position from data-color-index) so when the exact size is missing
// the addon still follows the selected color. Other products / the v2 block are NOT synced.
// Liquid: snippets/product-bundle-addon.liquid
(function() {
  function norm(s) { return String(s == null ? '' : s).trim().toLowerCase(); }
  function tokensFromTitle(title) {
    return String(title || '').split('/').map(norm).filter(Boolean);
  }
  function addonEl() { return document.querySelector('[data-bundle-addon][data-bundle-sync]'); }

  function syncAddon(mainValues) {
    var addon = addonEl();
    if (!addon) return;
    var mainTokens = (mainValues || []).map(norm).filter(Boolean);
    if (!mainTokens.length) return;
    var ci = parseInt(addon.getAttribute('data-color-index'), 10);
    var mainColor = (ci >= 0 && mainValues[ci] != null) ? norm(mainValues[ci]) : null;

    Array.prototype.forEach.call(addon.querySelectorAll('[data-bundle-variant-select]'), function(select) {
      var best = null, bestScore = 0;
      Array.prototype.forEach.call(select.options, function(opt) {
        if (opt.disabled) return; // never auto-select a sold-out addon variant
        var tokens = tokensFromTitle(opt.dataset.title || (opt.textContent || '').split(' — ')[0]);
        if (!tokens.length) return;
        var score = tokens.filter(function(t) { return mainTokens.indexOf(t) !== -1; }).length;
        if (mainColor && tokens.indexOf(mainColor) !== -1) score += 0.5; // color outranks size on ties
        if (score > bestScore) {
          best = opt; bestScore = score;
        }
      });
      if (best && bestScore > 0 && select.value !== best.value) {
        select.value = best.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function valuesFromVariant(v) {
    if (!v) return null;
    if (v.options && v.options.length) return v.options;
    if (v.title) return v.title.split(' / ');
    return null;
  }

  // Read the main product's currently selected option values from the DOM (initial load).
  function valuesFromDOM() {
    var addon = addonEl();
    if (!addon) return null;
    var scope = addon.closest('.product-section') || document;
    var byIndex = {};
    Array.prototype.forEach.call(scope.querySelectorAll('input[type="radio"][data-index^="option"]:checked'), function(r) { byIndex[r.dataset.index] = r.value; });
    Array.prototype.forEach.call(scope.querySelectorAll('select[data-index^="option"]'), function(s) { if (s.value) byIndex[s.dataset.index] = s.value; });
    var keys = Object.keys(byIndex).sort();
    return keys.length ? keys.map(function(k) { return byIndex[k]; }) : null;
  }

  // Only the main product's own variant changes should drive the sync (ignore quick-shop etc.).
  function isMainVariant(id) {
    var addon = addonEl();
    if (!addon) return false;
    var scope = addon.closest('.product-section') || document;
    var master = scope.querySelector('select[name="id"], [name="id"]');
    if (!master || !master.options || !master.options.length) return true;
    return Array.prototype.some.call(master.options, function(o) { return String(o.value) === String(id); });
  }

  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant && isMainVariant(e.detail.variant.id)) {
      syncAddon(valuesFromVariant(e.detail.variant));
    }
  });

  function initSync() { syncAddon(valuesFromDOM()); }
  document.addEventListener('DOMContentLoaded', initSync);
  document.addEventListener('page:loaded', initSync);
})();


// 13. Delivery Date Cart Sync
// The PDP (snippets/delivery-date.liquid) stores the estimate as a STATIC line item
// property "Expected delivery" plus a hidden "_delivery_days" range carrier. Without
// this sync the stored value would freeze at the add-to-cart date.
// On page load we recompute every cart line's estimate from TODAY using that line's
// own _delivery_days range; when it has drifted (i.e. a new day) we overwrite the
// property via /cart/change.js so cart, checkout AND the order email stay current.
// Runs once per load (NOT on cart:build): change.js only fires on an actual diff, so
// same-day loads make zero writes and there is no rebuild loop.
(function() {
  var DEFAULT_MIN = 14;   // fallback for legacy items added before _delivery_days existed
  var DEFAULT_MAX = 20;   // keep in sync with snippets/delivery-date.liquid data-*-days
  var SUFFIX = ' with standard shipping.';
  var PROP = 'Expected delivery';

  // Same formula + format as snippets/delivery-date.liquid so same-day values match.
  function buildValue(minDays, maxDays) {
    var options = { month: 'short', day: 'numeric' };
    var minDate = new Date();
    minDate.setDate(minDate.getDate() + minDays);
    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + maxDays);
    return minDate.toLocaleDateString('en-US', options) + ' - ' +
           maxDate.toLocaleDateString('en-US', options) + SUFFIX;
  }

  function parseDays(raw) {
    var min = DEFAULT_MIN, max = DEFAULT_MAX;
    if (raw) {
      var parts = String(raw).split('-');
      var a = parseInt(parts[0], 10);
      var b = parseInt(parts[1], 10);
      if (!isNaN(a)) min = a;
      if (!isNaN(b)) max = b;
    }
    return { min: min, max: max };
  }

  function syncDeliveryDates() {
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart || !cart.items || !cart.items.length) return;

        // Collect the lines that drifted before mutating anything — each line's key
        // stays valid until that specific line is changed.
        var pending = [];
        cart.items.forEach(function(item) {
          var props = item.properties;
          if (!props || !props[PROP]) return;
          var days = parseDays(props['_delivery_days']);
          var fresh = buildValue(days.min, days.max);
          if (props[PROP] !== fresh) {
            var newProps = Object.assign({}, props); // preserve every other property (_delivery_days, Customily, etc.)
            newProps[PROP] = fresh;
            pending.push({ key: item.key, quantity: item.quantity, properties: newProps });
          }
        });
        if (!pending.length) return;

        // Apply sequentially — the cart mutates on every change.
        var chain = Promise.resolve();
        pending.forEach(function(p) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: p.key, quantity: p.quantity, properties: p.properties })
            });
          });
        });
        chain.then(function() {
          // Refresh drawer + cart page with the corrected values.
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
      })
      .catch(function() { /* network hiccup — leave the stored value as-is */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDeliveryDates);
  } else {
    syncDeliveryDates();
  }
})();


// 15. PDP Fabric — video slide + tab switching
// Moved out of sections/fabric-video-tabs.liquid: inline there it only wired the FIRST
// instance (querySelector) and never re-ran after editor section reloads.
// Liquid: sections/fabric-video-tabs.liquid
(function() {
  function initFabricSections() {
    document.querySelectorAll('.pdp-fabric-section').forEach(function(section) {
      if (section.dataset.fabricInit === '1') return;
      section.dataset.fabricInit = '1';

      var slides = section.querySelectorAll('.pdp-fabric-slide');
      var nameEl = section.querySelector('.pdp-fabric-name');
      var titleEl = section.querySelector('.pdp-fabric-title');
      var bodyEl = section.querySelector('.pdp-fabric-body');
      var thumbs = section.querySelectorAll('.pdp-fabric-thumb');

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var index = parseInt(thumb.getAttribute('data-index'), 10);

          slides.forEach(function(slide, i) {
            if (i === index) {
              slide.classList.add('is-active');
              slide.setAttribute('aria-hidden', 'false');
              slide.play().catch(function() {});
            } else {
              slide.classList.remove('is-active');
              slide.setAttribute('aria-hidden', 'true');
            }
          });

          if (nameEl) nameEl.textContent = thumb.getAttribute('data-name');
          if (titleEl) titleEl.textContent = thumb.getAttribute('data-headline');
          if (bodyEl) bodyEl.textContent = thumb.getAttribute('data-body');

          thumbs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
        });
      });

      var allVideos = section.querySelectorAll('video');
      if (!('IntersectionObserver' in window)) {
        allVideos.forEach(function(v) { v.play().catch(function() {}); });
        return;
      }
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function() {});
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px' });
      allVideos.forEach(function(v) { observer.observe(v); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFabricSections);
  } else {
    initFabricSections();
  }
  document.addEventListener('page:loaded', initFabricSections);
  document.addEventListener('shopify:section:load', initFabricSections);
})();

// 16. Bundle Addon — "Show more / Show less" toggle
// Toggles the hidden same-print rows (.bundle-addon__item--more) in the v1 block and swaps
// the button label. Delegated so it also covers blocks re-rendered by the theme editor.
// Liquid: snippets/product-bundle-addon.liquid, snippets/bundle-addon-item.liquid
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bundle-more]');
    if (!btn) return;
    var addon = btn.closest('.bundle-addon');
    if (!addon) return;
    var expanded = addon.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var label = btn.querySelector('.bundle-addon__more-label');
    if (label) {
      var next = expanded ? label.getAttribute('data-less-label') : label.getAttribute('data-more-label');
      if (next) { label.textContent = next; }
    }
  });
})();

// 17. Collection Hero Categories — split-layout arrows
// The category row is a native horizontal scroller; the arrows just scrollBy() it.
// Adds .is-scrollable on the viewport only while the row overflows (CSS shows the arrows
// on desktop only) and disables the arrow at either end. Rebinds on editor section reloads.
// Liquid: sections/collection-hero-categories.liquid (layout "split"), CSS: custom.css section 40
(function() {
  function bind(viewport) {
    if (viewport.dataset.chcBound) return;
    viewport.dataset.chcBound = 'true';
    var track = viewport.querySelector('.collection-category-scroller__track');
    var prev = viewport.querySelector('[data-chc-prev]');
    var next = viewport.querySelector('[data-chc-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      viewport.classList.toggle('is-scrollable', max > 1);
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }
    function go(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
    }

    prev.addEventListener('click', function() { go(-1); });
    next.addEventListener('click', function() { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  function init() {
    document.querySelectorAll('[data-chc-scroller]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

// 18. Judge.me review widget: hydrate on approach
// sections/apps.liquid renames data-entry-point to data-jdgm-lazy-entry-point on the product
// review widget, so Judge.me's loader.js skips it at load (its Vue hydration is a 500-600 ms
// main-thread task on mobile). Here the attribute is renamed back when the widget comes within
// 1500px of the viewport, after the first scroll (idle), on a review badge click, or right away for review-email links
// (#judgeme hash, judgeme_* query tokens), and the steps loader.js would have run follow:
// hide the legacy markup, drop the SSR list, add the manifest CSS, load the widget module once.
// Cards carousel (home): same path minus the revamp check (loader.js loads carousels unconditionally),
// plus the queued inline loadSpecificScript() calls (window.jdgmLazyCarousels, see sections/apps.liquid).
// CSS: custom.css section 43.
(function() {
  var LAZY_ATTR = 'data-jdgm-lazy-entry-point';
  // Same list as loader.js: these links open the review form and must not wait for a scroll
  var TOKENS = ['judgeme_token', 'judgeme_review_uuid', 'judgeme_dynamic_form', 'judgeme_follow_up_token', 'judgeme_upload_pictures', 'judgeme_pre_verified'];

  function addCss(base, href) {
    var url = base + href;
    if (document.querySelector('link[href="' + url + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }

  function addManifestCss(base, manifest, key, seen) {
    var entry = manifest[key];
    if (!entry || seen[key]) return;
    seen[key] = true;
    (entry.css || []).forEach(function(href) { addCss(base, href); });
    (entry.imports || []).forEach(function(k) { addManifestCss(base, manifest, k, seen); });
  }

  // Same decision loader.js makes for the review widget (revamp vs legacy content)
  function shouldLoadRevamp(el) {
    var settings = window.jdgmSettings || {};
    var legacy = el.querySelector('.jdgm-legacy-widget-content');
    var hasLegacy = !!legacy && legacy.innerHTML.trim().length > 20;
    var widgets = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    var data = widgets && widgets[el.dataset.productId];
    var hasRevamp = !!(data && data.reviews !== undefined);
    return settings.review_widget_revamp_enabled ? (hasRevamp || !hasLegacy) : (!hasLegacy && hasRevamp);
  }

  function hydrate(el) {
    if (!el.hasAttribute(LAZY_ATTR)) return;
    var entryPoint = el.getAttribute(LAZY_ATTR);
    el.removeAttribute(LAZY_ATTR);
    el.setAttribute('data-entry-point', entryPoint);

    var isCarousel = /carousel/.test(el.dataset.widget || '');
    if (isCarousel) {
      var queue = window.jdgmLazyCarousels || [];
      window.jdgmLazyCarousels = [];
      queue.forEach(function(start) { start(); });
    }

    var ssr = el.querySelector('.jdgm-ssr-reviews');
    if (!isCarousel && !shouldLoadRevamp(el)) {
      var legacy = el.querySelector('.jdgm-legacy-widget-content');
      if (legacy) legacy.style.display = '';
      if (ssr) ssr.remove();
      return;
    }
    var base = window.jdgm && window.jdgm.CDN_BASE_URL;
    if (!base) return;
    var widg = el.querySelector('.jdgm-rev-widg');
    if (widg) widg.style.display = 'none';
    if (ssr) ssr.remove();

    var src = base + entryPoint;
    function addModule() {
      if (document.querySelector('script[src="' + src + '"]')) return;
      var script = document.createElement('script');
      script.type = 'module';
      script.src = src;
      document.head.appendChild(script);
    }
    fetch(base + 'manifest.json?v=' + Date.now())
      .then(function(r) { return r.json(); })
      .then(function(manifest) { addManifestCss(base, manifest, el.dataset.entryKey, {}); })
      .catch(function() {})
      .then(addModule);
  }

  function hydrateAll() {
    document.querySelectorAll('[' + LAZY_ATTR + ']').forEach(hydrate);
  }

  function init() {
    var widgets = document.querySelectorAll('[' + LAZY_ATTR + ']');
    if (!widgets.length) return;
    // Drop the hidden SSR list now, as loader.js does at load: left in the DOM, Judge.me's legacy scripts customise its reviews and load media.js
    widgets.forEach(function(w) { var s = w.querySelector('.jdgm-ssr-reviews'); if (s) s.remove(); });
    var search = window.location.search;
    var fromEmail = window.location.hash.indexOf('#judgeme') === 0 ||
      TOKENS.some(function(t) { return search.indexOf(t) >= 0; });
    if (fromEmail || !('IntersectionObserver' in window)) {
      hydrateAll();
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        hydrate(entry.target.jdgmLazyWidget || entry.target);
      });
    }, { rootMargin: '1500px 0px 1500px 0px' });
    // The carousel stays display:none (.jdgm-hidden) until built, which never intersects: observe its app block instead
    widgets.forEach(function(w) {
      var target = w.closest('.shopify-app-block') || w;
      target.jdgmLazyWidget = w;
      io.observe(target);
    });
    // Mount right after the first scroll while the widget is still far below: mounting in view would push ~4.5k px of content down (field CLS)
    window.addEventListener('scroll', function() {
      if ('requestIdleCallback' in window) requestIdleCallback(hydrateAll, { timeout: 2000 });
      else setTimeout(hydrateAll, 200);
    }, { passive: true, once: true });
  }

  // A review badge click scrolls to the widget (section 10): start hydrating right away
  document.addEventListener('click', function(e) {
    if (e.target.closest('.jdgm-prev-badge, .review-badge, a[href*="#judgeme"]')) hydrateAll();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
